import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {getRegistrationFlowUserState} from "../auth/utils/get_registration_flow_user_state";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = getRegistrationFlowUserState(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    return {
        shouldHidePrices: (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        hasPhone,
        hasName,
        isUserLoggedIn
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {getRegistrationFlowUserState} from "../auth/utils/get_registration_flow_user_state";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = getRegistrationFlowUserState(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    return {
        shouldHidePrices: (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        hasPhone,
        hasName,
        isUserLoggedIn
    };
};
